<template>
  <img :src="imageUrl" :alt="alt" />
</template>

<script>

import { getActivityImage } from '@/api/activity.js';

export default {
  name: 'ActivityImage',
  props: {
    activity: {
      type: [Number, String],
      required: true,
    },
    alt: {
      type: String,
      required: false,
    },
  },

  data() {
    return{
      imageUrl: null
    }
  },


  //TODO: remove?
  computed: {
    activityType() {
      return this.$store.state.descriptions.activityType;
    },
    currentActivityValue() {
      const { activity, activityType } = this;

      return activityType.find(
        (type) => type.description === activity || type.value === activity,
      ).logoKey;
    },
  },

  methods: {
    async fetchImage() {

      //todo: cache image

      try {
       
        // Fetch image data as blob from the API
        const imageBlob = await getActivityImage(this.activity);

        // Revoke any previous object URL to avoid memory leaks
        if (this.imageURL) {
          URL.revokeObjectURL(this.imageURL);
        }
        
        // Create an object URL from the blob and assign it to imageUrl
        this.imageUrl = URL.createObjectURL( imageBlob);

        //console.log("ImageURL: " + this.imageURL);

      } catch (error) {
        console.error('Error fetching the image:', error);
        this.error = "Failed to load image. Please try again.";
        this.imageUrl = null;
      }
    },
  },

  created() {
    this.fetchImage();
  },

};
</script>
